/**
 * What a frame's `thumbnail` pictures, from `thumbnailSource` — set by Studio's
 * frame editor (dreambooth lib/frames/frameThumbnail.ts):
 *
 *  - "auto"   the whole canvas, re-captured on every editor save. Absent means
 *             this: it was the only behaviour before the setting existed.
 *  - "strip"  the canvas cropped to its first strip (a 1:4 strip of a 3:4 sheet).
 *  - "upload" a picture the operator uploaded; any shape, any content.
 *
 * Only "auto" has the canvas's shape and layout, so only then may a screen lay
 * the thumbnail under photo slots positioned in canvas coordinates.
 */
export type FrameThumbnailSource = 'auto' | 'strip' | 'upload'

/** True unless the thumbnail is a strip or an upload. Unknown values read as "auto", as in Studio. */
export function thumbnailShowsWholeCanvas(thumbnailSource: unknown): boolean {
  return thumbnailSource !== 'strip' && thumbnailSource !== 'upload'
}
